import * as marietta from '../..';
import { ItemLayer } from '.';

export default class SiteLayer extends ItemLayer {
  private _mode: number = 0; // 0：簡易 , 1:複数区画

  get mode() { return this._mode; }

  set mode(modeNo: number) { this._mode = modeNo; }

  /**
   * 総敷地面積の取得
   * @return number
   */
  getAreaAll(): number {
    let retValue: number = 0;
    for (let i = 0, len = this.childList.length; i < len; i += 1) {
      if (((this.childList[i] as any) instanceof marietta.webcad.item.Site)) {
        retValue += ((this.childList[i] as marietta.webcad.item.Site).getArea());
      }
    }
    return retValue;
  }

  initMe(): void {
    this.removeAllChildren();
  }

  /**
   * 1個目の敷地の取得
   */
  // eslint-disable-next-line consistent-return
  getFirstSite() {
    if (this.childList.length > 0) {
      return this.childList[0];
    }
  }

  updateLineLockInfo() {
    const allItems = this.getAllChildren() as marietta.webcad.item.Site[];
    let allItemsLineList: marietta.webcad.item.parts.SiteLine[] = [];

    let lineList: marietta.webcad.item.parts.SiteLine[] = [];
    for (let i = 0; i < allItems.length; i += 1) {
      lineList = allItems[i].lines;
      for (let k = 0; k < lineList.length; k += 1) {
        (lineList[k] as marietta.webcad.item.parts.SiteLine).locked = false;
      }
      allItemsLineList = allItemsLineList.concat(lineList);
    }

    if (allItems.length < 2) return;

    for (let i = 0; i < allItemsLineList.length; i += 1) {
      for (let k = 0; k < allItemsLineList.length; k += 1) {
        if (allItemsLineList[i] !== allItemsLineList[k] && (allItemsLineList[i].parent.itemInfo.guid !== allItemsLineList[k].parent.itemInfo.guid)
          && (this.isOverlappedLine(allItemsLineList[i], allItemsLineList[k]))) {
          allItemsLineList[i].locked = true;
          allItemsLineList[k].locked = true;
        }
      }
    }
  }

  isOverlappedLine = (line1: marietta.webcad.item.parts.SiteLine, line2: marietta.webcad.item.parts.SiteLine): boolean => {
    // 始点・終点同士
    let dot1: marietta.core.Point;
    let dot2: marietta.core.Point;
    dot1 = new marietta.core.Point(line1.firstDot.x + line1.parent.itemInfo.x, line1.firstDot.y + line1.parent.itemInfo.y);
    dot2 = new marietta.core.Point(line2.firstDot.x + line2.parent.itemInfo.x, line2.firstDot.y + line2.parent.itemInfo.y);
    if (marietta.core.Point.distance(dot1, dot2) < 5) {
      dot1 = new marietta.core.Point(line1.secondDot.x + line1.parent.itemInfo.x, line1.secondDot.y + line1.parent.itemInfo.y);
      dot2 = new marietta.core.Point(line2.secondDot.x + line2.parent.itemInfo.x, line2.secondDot.y + line2.parent.itemInfo.y);
      if (marietta.core.Point.distance(dot1, dot2) < 5) return true;
      return false;
    }
    dot1 = new marietta.core.Point(line1.firstDot.x + line1.parent.itemInfo.x, line1.firstDot.y + line1.parent.itemInfo.y);
    dot2 = new marietta.core.Point(line2.secondDot.x + line2.parent.itemInfo.x, line2.secondDot.y + line2.parent.itemInfo.y);
    if (marietta.core.Point.distance(dot1, dot2) < 5) {
      dot1 = new marietta.core.Point(line1.secondDot.x + line1.parent.itemInfo.x, line1.secondDot.y + line1.parent.itemInfo.y);
      dot2 = new marietta.core.Point(line2.firstDot.x + line2.parent.itemInfo.x, line2.firstDot.y + line2.parent.itemInfo.y);
      if (marietta.core.Point.distance(dot1, dot2) < 5) return true;
      return false;
    }
    return false;
  }

  putLayerItemsInGroup() {
    const allItems = this.getAllChildren();
    marietta.webcad.WebCADGlobal.itemManager.addItems(allItems);
    this.updateLineLockInfo();
  }
}
